module.exports = __webpack_public_path__ + "static/media/hand.f04651a2.svg";